import { getApplicationHost } from 'src/data/system';
import { formatRoute } from 'src/lib/routing';
import { preparePlatformUrl } from 'src/lib/url';
import { ROUTE_PARAMS, ROUTES } from 'src/routes';

const formatExternalPlatformLink = (route, options = {}) => {
  const mergedOptions = { ...options };

  const host = getApplicationHost();
  if (host) {
    mergedOptions[ROUTE_PARAMS.host] = host;
  }

  const path = formatRoute(route, mergedOptions);
  return preparePlatformUrl(path);
};

export const formatBrandBriefsLink = () => formatExternalPlatformLink(ROUTES.BRAND_BRIEFS);

export const formatTalkingPointsLink = () =>
  formatExternalPlatformLink(ROUTES.PERFORMANCE_TALKING_POINTS);

export const formatPersonasLink = () => formatExternalPlatformLink(ROUTES.PERSONAS);

export const formatTonesOfVoiceLink = () => formatExternalPlatformLink(ROUTES.TONE_OF_VOICE);

export const formatConnectChannelLink = (channel) =>
  formatExternalPlatformLink(ROUTES.PERFORMANCE_ADS, { [ROUTE_PARAMS.channel]: channel });

export const formatBrandRulesLink = () => formatExternalPlatformLink(ROUTES.BRAND_GUIDELINES);

export const formatUpgradeLink = () => formatExternalPlatformLink(ROUTES.UPGRADE);
